import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=e6345540&"
import script from "./TableComponent.vue?vue&type=script&lang=ts&"
export * from "./TableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6345540')) {
      api.createRecord('e6345540', component.options)
    } else {
      api.reload('e6345540', component.options)
    }
    module.hot.accept("./TableComponent.vue?vue&type=template&id=e6345540&", function () {
      api.rerender('e6345540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/TableComponent.vue"
export default component.exports